import { render, staticRenderFns } from "./tops.vue?vue&type=template&id=c518b48c&scoped=true"
import script from "./tops.vue?vue&type=script&lang=js"
export * from "./tops.vue?vue&type=script&lang=js"
import style0 from "./tops.vue?vue&type=style&index=0&id=c518b48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518b48c",
  null
  
)

export default component.exports